<template>
  <div>
    <vs-row>
      <vs-card
        id="loading"
        class="bg-header vs-con-loading__container"
        style="border-radius: 20px"
      >
        <div class="mt-2">
          <vs-row id="center">
            <h2 style="font-weight: 700; color: #31394d">
              {{ buiding_name }} Building
            </h2> </vs-row
          ><br /><br />
          <vs-table hoverFlat="false" :data="tables">
            <template slot="thead">
              <vs-th> </vs-th>
              <vs-th v-for="i in heaherlabel" :key="i">
                {{ i }}
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].email">
                  <vs-button
                    @click="goto(buiding_name, tr)"
                    color="success"
                    type="flat"
                    icon="add_circle"
                    >View</vs-button
                  >
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].data.Active_power">
                  {{
                    data[indextr].name == "Power Quality"
                      ? Math.floor(
                          data[indextr].data.Active_power / 1000
                        ).toLocaleString()
                      : Math.floor(
                          data[indextr].data.Active_power
                        ).toLocaleString()
                  }}
                </vs-td>

                <vs-td :data="data[indextr].id">
                  {{
                    Math.floor(
                      data[indextr].data.Current_1 +
                        data[indextr].data.Current_2 +
                        data[indextr].data.Current_3
                    ).toLocaleString()
                  }}
                </vs-td>
                <vs-td :data="data[indextr].data.Voltage_V12">
                  {{
                    data[indextr].name == "Power Quality"
                      ? Math.floor(
                          data[indextr].data.Voltage_V12 / 100
                        ).toLocaleString()
                      : data[indextr].data.Voltage_V12 == undefined
                      ? "-"
                      : Math.floor(
                          data[indextr].data.Voltage_V12
                        ).toLocaleString()
                  }}
                </vs-td>
                <vs-td :data="data[indextr].data.Voltage_V23">
                  {{
                    data[indextr].name == "Power Quality"
                      ? Math.floor(
                          data[indextr].data.Voltage_V23 / 100
                        ).toLocaleString()
                      : data[indextr].data.Voltage_V23 == undefined
                      ? "-"
                      : Math.floor(
                          data[indextr].data.Voltage_V23
                        ).toLocaleString()
                  }}
                </vs-td>
                <vs-td :data="data[indextr].data.Voltage_V31">
                  {{
                    data[indextr].name == "Power Quality"
                      ? Math.floor(
                          data[indextr].data.Voltage_V31 / 100
                        ).toLocaleString()
                      : data[indextr].data.Voltage_V31 == undefined
                      ? "-"
                      : Math.floor(
                          data[indextr].data.Voltage_V31
                        ).toLocaleString()
                  }}
                </vs-td>
                <vs-td :data="data[indextr].data.Power_factor">
                  {{
                    data[indextr].data.Power_factor == undefined
                      ? "-"
                      : decimalAdjust(
                          "floor",
                          data[indextr].data.Power_factor,
                          -2
                        )
                  }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </vs-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    headerFilter: ["Code", "Name"],
    selectData: [],
    viewdata: "",
    searchHeader: "",
    selectFilterName: "",
    selectFilterCode: "",
    getDataLocation: [],
    selected: [],
    selected: [],

    heaherlabel: [
      "ไลน์เครื่องจักร/แผนก",
      "kWh",
      "Amp",
      "V1",
      "V2",
      "V3",
      "Power Factor",
    ],
    totalRows: 1,
    currentPage: 1,
    perPage: 5,
    pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    filter: null,
    filterOn: [],
    infoModal: {
      id: "info-modal",
      title: "",
      content: "",
    },
    tables: [],
    buiding_name: "",
  }),
  methods: {
    goto(buiding_name, item) {
      let path_name = buiding_name.replace(/\s+/g, "");
      let path_name_machine = item.name.replace(/\s+/g, "");
      this.$session.set("data", item);
      // this.$router.push({
      //   path: "/Machinelist/" + path_name + "/" + item.device,
      // });

      if (this.$route.path.includes("PublicAjinomoto")) {
        this.$router.push({
          path: "/PublicAjinomoto/Machinelist/" + path_name + "/" + item.device,
        });
      } else {
        this.$router.push({
          path: "/Machinelist/" + path_name + "/" + item.device,
        });
      }
    },
    decimalAdjust(type, value, exp) {
      type = String(type);
      if (!["round", "floor", "ceil"].includes(type)) {
        throw new TypeError(
          "The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'."
        );
      }
      exp = Number(exp);
      value = Number(value);
      if (exp % 1 !== 0 || Number.isNaN(value)) {
        return NaN;
      } else if (exp === 0) {
        return Math[type](value);
      }
      const [magnitude, exponent = 0] = value.toString().split("e");
      const adjustedValue = Math[type](`${magnitude}e${exponent - exp}`);
      // Shift back
      const [newMagnitude, newExponent = 0] = adjustedValue
        .toString()
        .split("e");
      return Number(`${newMagnitude}e${+newExponent + exp}`);
    },
    link2dash(item) {
      console.log(item.branch_code);
      this.$session.set("branch_code", item[0].branch_code);
      this.$session.set("data", item[0]);
      this.$router.push({
        path: "/MACdashboard?" + item[0].branch_code,
        params: { data: item[0], branch_code: item[0].branch_code },
      });
      //  this.$router.push({
      //   name: "SensorDashboard",
      //   params: {
      //     nwname: item,
      //   },
      // });
    },
  },
  async mounted() {
    // Set the initial number of items
    console.log(this.$route.params.building);
    this.buiding_name = this.$route.params.building;
    this.$vs.loading({
      type: "default",
      container: "#loading",
    });
    let res = await this.$API.get(
      `ajino-get-building/${this.$route.params.building}`
    );

    console.log(res.data);
    this.tables = res.data.message;
    this.$vs.loading.close("#loading > .con-vs-loading");
  },
  created() {
    //  console.log("aaaaaaaaaaaaaaaaaaaaaaa");
    // this.$API.get("mc/location").then((result) => {
    //   console.log(result.data);
    //   this.getDataLocation = result.data;
    //   // console.log("aaaaaaaaaaaaaaaaaaaaaaa");
    // });
  },
  computed: {},
};
</script>

<style lang="scss"scoped>
#center {
  display: flex;
  align-items: center;
}
.bg-header {
  width: 100%;
  background: linear-gradient(
    180deg,
    #48c93b 0px,
    var(--background-color-sidebar) 45px,
    var(--background-color-sidebar) 100px
  );
}
</style>